<template>
  <div
    v-scroll-lock-fill-gap
    :class="b({ stacked: compStacked, queued, swipe })"
    :style="style"
  >
    <transition-group
      :name="`${b()}-transition`"
      tag="div"
      :class="b('transition-group')"
    >
      <div
        v-for="item in items"
        :key="item.id"
        :class="b('notification-wrapper')"
        :style="notificationWrapperStyle"
      >
        <ga-notifications-swiper
          :class="b('notification-swiper')"
          :direction="compDirection"
          :axis="compAxis"
          :is-swiped="item.closeBySwipe"
          @swiped="onSwipeItem(item)"
        >
          <slot v-bind="{ item }">
            <component
              :is="getItemComponent(item)"
              :class="b('notification')"
              v-bind="getItemProps(item)"
              v-on="getItemListeners(item)"
              @close="destroy(item)"
              @click="onClickItem(item)"
              @mouseenter="onNotificationMouseenter(item)"
              @mouseleave="onNotificationMouseleave(item)"
            >
              <template #text>
                <span v-if="item.slotText" name="text" v-html="item.slotText" />
              </template>
            </component>
          </slot>
        </ga-notifications-swiper>
      </div>
    </transition-group>
  </div>
</template>

<script src="./notifications.script.js" />

<style src="./notifications.style.scss" lang="scss" />
